document.querySelectorAll('[data-related-products]').forEach((root) => {
  const url = root.dataset.url;
  if (!url) return;

  fetch(url)
    .then((response) => response.text())
    .then((text) => {
      const doc = new DOMParser().parseFromString(text, 'text/html');
      const newContent = doc.querySelector('[data-related-products-content]');
      const currentContent = root.querySelector('[data-related-products-content]');

      if (newContent && currentContent && newContent.innerHTML.trim() !== '') {
        currentContent.innerHTML = newContent.innerHTML;
      } else {
        root.remove();
      }
    })
    .catch(() => root.remove());
});
